import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Logo from "./logo";
import Navlinks from "./navlinks";
import "../style/footer.less";

export default function() {
    const query = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `);

    return (
        <footer className="footer">
            <div className="container">
                <div className="logo">
                    <Link to="/" title={query.site.siteMetadata.title}>
                        <Logo />
                    </Link>
                </div>
                <div className="navlinks text-secondary">
                    <Navlinks />
                </div>
                <p className="text-primary f-d">
                    Copyright &copy; <a href="https://kadyvillicana.com">Kady Villicaña{" "}</a> 
                    {new Date().getFullYear()}
                </p>
            </div>
        </footer>
    );
}
